import React from "react"

const Footer = ({onCancel, pristine, submitting}) => (
  <footer>
    <button  type="submit" disabled={pristine || submitting}>Save</button>
    <button type="button" disabled={submitting} onClick={onCancel}>Cancel</button>
  </footer>
)

export default Footer
